import React, { useState, useEffect } from 'react';
import './ConfiguratorPrivateConnect.css';
import { useParams } from 'react-router-dom';
import { Locale } from 'model/enums/locale';
function ConfiguratorPrivateConnect({
  addresses,
  targetPostcode,
  country,
  street,
  setSelectStep,
  PrivateData,
  setInstallerId,
  AnnoyCustomer,
  Translations,
  ConfigLink,
  setnothingbelow,
}) {
  const [postcodeCoords, setPostcodeCoords] = useState(null);
  const [distances, setDistances] = useState([]);
  const [ChoosenInstaller, setChoosenInstaller] = useState('');
  const [acceptData, setacceptData] = useState(false);
  const para = useParams();
  /*console.log('Addresses:', addresses);
  console.log('Target postcode:', targetPostcode);
  console.log('Country:', country);
  console.log('Street:', street);*/

  const handleNextStep = () => {
    //console.log(PrivateData);
    if (setSelectStep) {
      setSelectStep(11);
    }
  };

  useEffect(() => {
    if (para.count != 'it-it') {
      handleNextStep();
    }
  }, []);

  const popupconfig = () => {
    AnnoyCustomer(true);
    setwentback(true);
  };

  const [InstallerSlug, setInstallerSlug] = useState('');
  const [wentback, setwentback] = useState(0);
  useEffect(() => {
    console.log(InstallerSlug);
  }, [InstallerSlug]);

  // Function to fetch coordinates for the postcode
  const fetchCoordinates = async (query, count, street) => {
    let streety = street;

    let number = '8';
    const streetRegex = /^(.*?)(\d+.*)$/;
    let streetNumber = '';
    let streetName = '';
    const match = street.match(streetRegex);
    if (match) {
      streetName = match[1].trim();
      streetNumber = match[2].trim();
    }

    let shootquery = `${query}, ${country}`;
    if (streetNumber) {
      number = streetNumber;
      streety = streetName;
      /*console.log('Street number:', number);
      console.log('Street name:', streety);
      console.log('PostCode:', query);
      console.log('Country:', country);*/

      shootquery = `${number} ${streety}, ${query}, ${country}`;
      //console.log('Shootquery:', shootquery);
    }

    try {
      //const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${shootquery}`);
      const response = await fetch('https://strapi-qrailing.azurewebsites.net/api/geocacheapi', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ address: shootquery }),
      });

      const data = await response.json();
      if (data && data.results && data.results[0] && data.results[0].geometry && data.results[0].geometry.location) {
        //console.log(data);
        return {
          latitude: parseFloat(data.results[0].geometry.location.lat),
          longitude: parseFloat(data.results[0].geometry.location.lng),
        };
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error);
      setSelectStep(11);
      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${query},${count}`);
        const data = await response.json();
        if (data && data[0]) {
          return {
            latitude: parseFloat(data[0].lat),
            longitude: parseFloat(data[0].lon),
          };
        }
      } catch (error) {
        console.error('Error fetching coordinates:', error);
      }
    }
    return null;
  };

  // Haversine formula for distance calculation
  const haversineDistance = (coords1, coords2) => {
    const R = 6371; // Earth's radius in km
    const toRad = (value) => (value * Math.PI) / 180;

    const dLat = toRad(coords2.latitude - coords1.latitude);
    const dLon = toRad(coords2.longitude - coords1.longitude);

    const lat1 = toRad(coords1.latitude);
    const lat2 = toRad(coords2.latitude);

    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    //console.log('Distance:', R * c);
    return R * c; // Distance in km
  };

  useEffect(() => {
    const calculateDistances = async () => {
      const postcodeCoords = await fetchCoordinates(targetPostcode, country, street);
      if (!postcodeCoords) return;

      setPostcodeCoords(postcodeCoords);

      // Calculate distance to each address
      const distancesWithCoords = addresses.map((address) => {
        const distance = haversineDistance(postcodeCoords, address);
        return { ...address, distance };
      });

      // Sort by distance
      distancesWithCoords.sort((a, b) => a.distance - b.distance);

      if (distancesWithCoords.length > 0) {
        if (distancesWithCoords[0].distance.toFixed(2) > 4000) {
          handleNextStep();
        }
      }
      setDistances(distancesWithCoords);
      if (distancesWithCoords.length > 0) {
        if (distancesWithCoords[0].distance > 4000) {
          setSelectedInstaller('Skip');
          handleNextStep();
        }
      }
    };

    calculateDistances();
  }, [addresses, targetPostcode]);
  const [selectedInstaller, setSelectedInstaller] = useState(null);
  const selectInstaller = (index) => {
    setSelectedInstaller(index);
  };

  useEffect(() => {
    if (distances) {
      distances.map((address, index) => {
        if (parseInt(address.distance) > 0) {
          if (parseInt(address.distance) < 30) {
            setnothingbelow(false);
          }
        }
      });
    }
  }, [distances]);
  function SendInstallerConnectRequest(slug) {
    let email;
    let phone;
    let name;
    let postcode;
    let address;
    let country = para.count;
    let city;
    let installermail = 'rene.hartjes@q-railing.com';
    let installerphone = '12345';
    let installername = 'Rene Hartjes';
    let token = process.env.REACT_APP_PUBLIC_KEY2;
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    };

    fetch('https://strapi-qrailing.azurewebsites.net/api/premiumcustomers?filters[Slug][$eq]=' + slug, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          installermail = data.data[0].attributes.Email;
          installerphone = data.data[0].attributes.Phone;
          installername = data.data[0].attributes.DisplayName;
        }

        if (PrivateData) {
          email = PrivateData.mail;
          phone = PrivateData.phone;
          name = PrivateData.fname + PrivateData.lname;
          postcode = PrivateData.postcode;
          address = PrivateData.street;
          city = PrivateData.city;
        }

        let reqbody = JSON.stringify({
          data: {
            Title: 'Premium Customer Request',
            CustomerAddress: address,
            CustomerEmail: email,
            CustomerName: name,
            CustomerPostCode: postcode,
            InstallerName: installername,
            InstallerEmail: installermail,
            InstallerPhone: installerphone,
            Locale: country,
            CustomerCity: city,
            CustomerPhone: phone,
            ConfigurationLink: ConfigLink,
            ConfigurationData: 'ConfigurationData',
          },
        });

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: reqbody,
        };
        //console.log(reqbody);
        handleNextStep();

        fetch('https://strapi-qrailing.azurewebsites.net/api/premiumcustomer-requests', requestOptions)
          .then((response) => response.json())
          .then(setTimeout(() => {}, 2000))
          .then((data) => {
            handleNextStep();
            this.setState({ postId: data.id });
          });
      });
  }
  return (
    <>
      {distances.length > 0 && (
        <>
          {
            <div className="ConfiguratorPrivateConnect-wrap">
              {/*<h4>Closest Addresses to {targetPostcode}</h4>
              <span>
                {street},{country}
              </span>*/}
              {distances.length > 0 ? (
                <div className="ConfiguratorPrivateConnect-Address-solutions">
                  <ul>
                    {distances.map((address, index) => (
                      <>
                        {parseInt(address.distance) < 30 && (
                          <li
                            key={index}
                            id={selectedInstaller === index && 'ConfiguratorPrivateConnect-activeInstallerLi'}
                            className="ConfiguratorPrivateConnect-InstallerLi"
                            onClick={() => {
                              selectInstaller(index);
                              setInstallerId(address.slug);
                              setInstallerSlug(address.slug);
                            }}
                          >
                            <input
                              onChange={() => {
                                selectInstaller(index);
                                setInstallerId(address.slug);
                                setInstallerSlug(address.slug);
                              }}
                              className="InputConfiguratorPrivateConnect"
                              id={'InstallerInput' + index}
                              type="radio"
                              checked={selectedInstaller === index}
                            />
                            <span>
                              <h3>{address.name}</h3>
                              <p>
                                <span>
                                  {address.postcode + ' '}
                                  {address.city}
                                </span>
                                <span>
                                  <svg
                                    width="9"
                                    height="12"
                                    viewBox="0 0 9 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.5 2.57145C4.09545 2.57145 3.69998 2.69713 3.36361 2.93259C3.02723 3.16806 2.76506 3.50273 2.61025 3.89429C2.45543 4.28585 2.41492 4.71671 2.49385 5.13239C2.57277 5.54807 2.76758 5.92989 3.05365 6.22958C3.33971 6.52926 3.70417 6.73335 4.10095 6.81604C4.49773 6.89872 4.909 6.85628 5.28276 6.69409C5.65652 6.53191 5.97598 6.25725 6.20073 5.90485C6.42549 5.55246 6.54545 5.13815 6.54545 4.71433C6.54545 4.14601 6.32995 3.60096 5.94635 3.19909C5.56276 2.79722 5.04249 2.57145 4.5 2.57145ZM4.5 6.00006C4.25727 6.00006 4.01999 5.92465 3.81816 5.78338C3.61634 5.6421 3.45904 5.4413 3.36615 5.20636C3.27326 4.97142 3.24895 4.71291 3.29631 4.4635C3.34366 4.21409 3.46055 3.985 3.63219 3.80519C3.80382 3.62537 4.0225 3.50292 4.26057 3.45331C4.49864 3.4037 4.7454 3.42916 4.96966 3.52648C5.19391 3.62379 5.38559 3.78858 5.52044 4.00002C5.65529 4.21146 5.72727 4.46004 5.72727 4.71433C5.72727 5.05533 5.59797 5.38236 5.36781 5.62348C5.13765 5.8646 4.82549 6.00006 4.5 6.00006ZM4.5 0C3.30694 0.00141791 2.16313 0.498561 1.31951 1.38236C0.475894 2.26616 0.00135344 3.46445 0 4.71433C0 6.39649 0.741989 8.17937 2.14773 9.87064C2.77937 10.6349 3.49029 11.323 4.26733 11.9224C4.33611 11.9729 4.41806 12 4.50205 12C4.58603 12 4.66798 11.9729 4.73676 11.9224C5.51237 11.3228 6.2219 10.6346 6.85227 9.87064C8.25597 8.17937 9 6.39649 9 4.71433C8.99865 3.46445 8.52411 2.26616 7.68049 1.38236C6.83687 0.498561 5.69306 0.00141791 4.5 0ZM4.5 11.0358C3.65472 10.3394 0.818182 7.78133 0.818182 4.71433C0.818182 3.69134 1.20609 2.71026 1.89656 1.98689C2.58704 1.26353 3.52352 0.857151 4.5 0.857151C5.47648 0.857151 6.41296 1.26353 7.10344 1.98689C7.79391 2.71026 8.18182 3.69134 8.18182 4.71433C8.18182 7.78026 5.34528 10.3394 4.5 11.0358Z"
                                      fill="#666666"
                                    />
                                  </svg>
                                  {Math.round(address.distance.toFixed(2))}km
                                </span>
                              </p>
                            </span>
                          </li>
                        )}
                      </>
                    ))}
                    <div className="ConfiguratorPrivateConnect-InstallerLi-linewrap">
                      <li
                        className="ConfiguratorPrivateConnect-InstallerLi"
                        id={selectedInstaller === 99 && 'ConfiguratorPrivateConnect-activeInstallerLi'}
                        onClick={() => {
                          selectInstaller(99);
                          InstallerSlug != 'None' && setInstallerSlug('None');
                          setInstallerId('None');
                        }}
                      >
                        <input
                          onChange={() => {
                            selectInstaller(99);
                            InstallerSlug != 'None' && setInstallerSlug('None');
                            setInstallerId('None');
                          }}
                          className="InputConfiguratorPrivateConnect"
                          id={'InstallerInput99'}
                          type="radio"
                          checked={selectedInstaller === 99}
                        />
                        <span>
                          <h3>{Translations && Translations.data[0].attributes.FreeData1.data[226]}</h3>
                          <p>{Translations && Translations.data[0].attributes.FreeData1.data[227]}</p>
                        </span>
                      </li>
                    </div>
                  </ul>

                  {InstallerSlug != 'None' && (
                    <div className="CheckboxId">
                      <div>
                        <div>
                          <input
                            type="checkbox"
                            id=""
                            onChange={() => setacceptData(!acceptData)}
                            checked={acceptData}
                          />
                        </div>
                        <span id="checkdata-premiumcust" onClick={() => setacceptData(!acceptData)}>
                          {Translations && Translations.data[0].attributes.FreeData1.data[198]}
                        </span>
                      </div>
                    </div>
                  )}
                  <div className="ConfiguratorPrivateConnect-btnline">
                    <button
                      id="ConfiguratorPrivateConnect-SendInstallerRequest"
                      className={
                        (selectedInstaller != null && acceptData === true) || InstallerSlug == 'None'
                          ? 'ConfiguratorPrivateConnect-SendInstallerRequest-active'
                          : 'ConfiguratorPrivateConnect-SendInstallerRequest-not-active'
                      }
                      style={InstallerSlug == 'None' ? { marginTop: '62px' } : {}}
                      onClick={() => {
                        if (selectedInstaller != null && acceptData === true && InstallerSlug != 'None') {
                          SendInstallerConnectRequest(InstallerSlug);
                        } else {
                          //handleNextStep();
                          !wentback && setInstallerId('None');
                          !wentback && popupconfig();
                          wentback && handleNextStep();
                        }
                      }}
                    >
                      {InstallerSlug == 'None' ? (
                        <>{Translations && Translations.data[0].attributes.FreeData1.data[0]}</>
                      ) : (
                        <>{Translations && Translations.data[0].attributes.FreeData1.data[0]}</>
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                <p>Loading...</p>
              )}
            </div>
          }
        </>
      )}
    </>
  );
}

export default ConfiguratorPrivateConnect;
